import { render } from "./UpdateImageModal.vue?vue&type=template&id=b46055f8"
import script from "./UpdateImageModal.vue?vue&type=script&lang=js"
export * from "./UpdateImageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__